import { render, staticRenderFns } from "./KT-HomeDashboard.vue?vue&type=template&id=36ecea90&scoped=true&lang=pug&"
import script from "./KT-HomeDashboard.vue?vue&type=script&lang=js&"
export * from "./KT-HomeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./KT-HomeDashboard.vue?vue&type=style&index=0&id=36ecea90&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ecea90",
  null
  
)

export default component.exports